/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationDocumentStatusRequestViewModel } from "../types/CourseRegistrationDocumentStatusRequestViewModel.ts";
import { eDocumentationStatusSchema } from "./eDocumentationStatusSchema.ts";

export const courseRegistrationDocumentStatusRequestViewModelSchema = z.object({
  courseRegistrationId: z.optional(
    z.number().int().describe("ID da matrícula do curso."),
  ),
  personId: z.optional(z.number().int().describe("ID da pessoa.")),
  status: z.optional(
    z
      .lazy(() => eDocumentationStatusSchema)
      .describe(
        "0 = Pending | 1 = Approved | 2 = Rejected | 3 = ApprovedTemporary | ",
      ),
  ),
  enrollmentDocumentId: z.optional(
    z.number().int().describe("ID do documento de matrícula."),
  ),
  observationId: z
    .number()
    .int()
    .describe("ID da observação do motivo de rejeição do documento.")
    .nullish(),
}) as unknown as ToZod<CourseRegistrationDocumentStatusRequestViewModel>;
